import { _ } from "js/vendor";
import {
    LOAD_THEME,
    UPDATE_THEME,
    fontsActions,
    UPLOAD_FONT,
    RESET_THEME
} from "js/react/views/ThemeEditor/themeEditor_types";

const defaultState = { model: {}, attributes: {}, fonts: { list: [] } };

export default function themeEditorReducer(state = defaultState, action) {
    const { type, payload, result } = action;

    switch (type) {
        case LOAD_THEME:
            return {
                ...state,
                model: payload.theme,
                originalTheme: payload.originalTheme,
                attributes: payload.theme.attributes
            };

        case RESET_THEME:
            return defaultState;

        case UPDATE_THEME:
            // if we're updating to gradient, and not already set to gradient, save the default background color
            if (
                ["gradient", "reverseGradient"].includes(
                    payload.styleBackground
                ) &&
                !["gradient", "reverseGradient"].includes(
                    state.model.get("styleBackground")
                )
            ) {
                payload.lastDefaultBackgroundColor = state.model.get(
                    "defaultBackgroundColor"
                );
            } else if (payload.defaultBackgroundColor) {
                payload.lastDefaultBackgroundColor =
                    payload.defaultBackgroundColor;
            }

            state.model.set(payload);
            return { ...state, attributes: { ...state.model.attributes } };

        case fontsActions.fetchStart:
            return {
                ...state,
                fonts: { ...state.fonts, status: "started" }
            };

        case fontsActions.fetchSuccess:
            return {
                ...state,
                fonts: {
                    ...state.fonts,
                    list: result,
                    status: "success"
                }
            };

        case fontsActions.fetchError:
            return {
                ...state,
                fonts: {
                    ...state.fonts,
                    error: result,
                    status: "error"
                }
            };

        case UPLOAD_FONT:
            return {
                ...state,
                fonts: {
                    ...state.fonts,
                    list: [payload, ...state.fonts.list]
                }
            };

        default:
            return state;
    }
}
